function o(r) {
  if (!r)
    throw new Error("`contentType` is required");
  var e = r.toLowerCase().replace(/.*\//, "");
  if (!e)
    throw new Error("Unsupported `contentType`: " + r);
  return e;
}
export {
  o as default
};
//# sourceMappingURL=index.es472.js.map
